const billing =  [
    {
        path: '/billing',
        name: 'billing.index',
        component: () => import('@/pages/Billing/IndexPage.vue'),
        meta: {
            requiresAuth: true,
            need_project: false,
            layout: 'content',
            title: "pages.billing.title",
        }
    },
]

export default billing